import request from "@/utils/request";

export function pollenBottleViabilityTestGet(params) {
    return request({
        url: "/api/services/app/PollenBottleViabilityTest/Get",
        method: "GET",
        params
    });
}

export function pollenBottleViabilityTestGetAll(params) {
    return request({
        url: "/api/services/app/PollenBottleViabilityTest/GetAll",
        method: "GET",
        params
    });
}

export function pollenBottleViabilityTestCreate(data) {
    return request({
        url: "/api/services/app/PollenBottleViabilityTest/Create",
        method: "post",
        data
    });
}

export function pollenBottleViabilityTestCreateWithImages(data) {
    return request({
        url: "/api/services/app/PollenBottleViabilityTest/CreateWithImages",
        method: "post",
        data
    });
}

export function pollenBottleViabilityTestUpdate(data) {
    return request({
        url: "/api/services/app/PollenBottleViabilityTest/Update",
        method: "put",
        data
    });
}

export function pollenBottleViabilityTestDelete(params) {
    return request({
        url: "/api/services/app/PollenBottleViabilityTest/Delete",
        method: "delete",
        params
    });
}




// WEBPACK FOOTER //
// ./src/api/pollen_bottle_viability_test.js